import React from 'react'
import NewsFeedAdvertSign from './StyledNewsFeedAdvertSign'
import NewsFeedItem from './NewsFeedItem'

const NewsFeedItemAd = props => {
  const {
    box
  } = props

  return (
    <NewsFeedItem {...box}>
      <NewsFeedAdvertSign/>
    </NewsFeedItem>
  )
}

export default NewsFeedItemAd
